<script lang="ts">
    import type {GenericDatatypedFilterDefinition, TextFilterableDatatype} from '../../types';
    import DatatypeValueEditor from './DatatypeValueEditor.svelte';

    export let valueFilterDefinition: GenericDatatypedFilterDefinition<TextFilterableDatatype>;
</script>

<DatatypeValueEditor filterableDatatypeDefinition={valueFilterDefinition}/>